import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BannerNotification, Button } from '@frontend/design-system';
import { ListsCenteredContainer } from './lists-centered-container';

type Props = {
  retry: () => void;
};

export const ListsErrorState = ({ retry }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  return (
    <ListsCenteredContainer>
      <BannerNotification status='error'>{t('Error loading lists.')}</BannerNotification>
      <Button size='large' onClick={retry} css={{ marginTop: theme.spacing(2) }}>
        {t('Retry')}
      </Button>
    </ListsCenteredContainer>
  );
};
